import { render } from "./Users.vue?vue&type=template&id=97d795d4&scoped=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=97d795d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-97d795d4"

export default script